
<form  class="form" (ngSubmit)="onSubmit()" >
    <input type="text" name="title" [(ngModel)]="title" placeholder="Add Todo..">
    <input type="submit" value="Submit" class="btn" />
</form>